import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

/**
 * We have observed in our pages the router.query is empty sometimes
 * This might be caused due to "automatic static optimization"
 * https://nextjs.org/docs/pages/api-reference/functions/use-router
 * https://github.com/vercel/next.js/issues/12988
 * Though there is a router.isReady property it does not seem to be available
 * Hence adding this client side hook where we can reliably get the query string
 * This needs to be removed once we identify the root cause of the issue with router.query
 **/

function useWindowLocationSearchParams() {
  const router = useRouter();
  const [searchParams, setSearchParams] = useState(router.query ?? {});

  // run the effect once
  useEffect(() => {
    if (Object.keys(searchParams).length === 0) {
      setSearchParams(
        Object.fromEntries(
          new URLSearchParams(window.location.search).entries()
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return searchParams;
}
export default useWindowLocationSearchParams;
